import { attr, belongsTo, hasMany } from "@ember-data/model";
import dayjs from "dayjs";
import {
  validateDate,
  validatePresence
} from "ember-changeset-validations/validators";
import type IntlService from "ember-intl/services/intl";
import JournalEvent from "parog-web/models/journal-event";
import type Patient from "parog-web/models/patient";
import tWithDefault from "parog-web/utils/t-with-default";
import type HemodialysisMeasuredJournalEvent from "./hemodialysis-measured-journal-event";
//---- Automatically generated, don't update this part ----

export default class HemodialysisSessionDeclaredJournalEvent extends JournalEvent {
  static override type = "hemodialysis-session-declared-journal-event";

  /**
   * specifies whether the session is in progress or completed
   */
  @attr("boolean", {
    allowNull: true
  })
  declare isDraft: boolean;

  @hasMany("hemodialysis-measured-journal-event", {
    async: false,
    inverse: "hemodialysisSessionDeclaredJournalEvent"
  })
  declare hemodialysisMeasuredJournalEvents: HemodialysisMeasuredJournalEvent[];

  static override validations(intl: IntlService) {
    return {
      occurredAt: [
        validatePresence({
          presence: true,
          description: tWithDefault(
            intl,
            "validations.hemodialysis-session-declared-journal-event.occurred-at",
            "La date"
          )
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée avant 1900. Veuillez modifier la date",
          onOrAfter: new Date("01/01/1900")
        }),
        validateDate({
          message:
            "Cette donnée ne peut être déclarée plus de 50 ans en avance. Veuillez modifier la date",
          onOrBefore: dayjs().add(50, "years").toDate()
        })
      ]
    };
  }

  //---- End of generated code ----
  @belongsTo("patient", {
    async: false,
    inverse: "hemodialysisSessionDeclaredJournalEvents"
  })
  declare patient: Patient;

  get startMeasurement(): HemodialysisMeasuredJournalEvent | undefined {
    return this.hemodialysisMeasuredJournalEvents.find(
      m => m.moment === "start" && !m.isArchived
    );
  }

  get middleMeasurements(): HemodialysisMeasuredJournalEvent[] {
    return this.hemodialysisMeasuredJournalEvents.filter(
      m => m.moment === "middle" && !m.isArchived
    );
  }

  get endMeasurement(): HemodialysisMeasuredJournalEvent | undefined {
    return this.hemodialysisMeasuredJournalEvents.find(
      m => m.moment === "end" && !m.isArchived
    );
  }
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module "ember-data/types/registries/model" {
  export default interface ModelRegistry {
    "hemodialysis-session-declared-journal-event": HemodialysisSessionDeclaredJournalEvent;
  }
}
